<template>
  <editor :api-key="apiKey" :value="value" :init="tinyMceInit" :name="name" @input="input" @onRemove="remove"></editor>
</template>

<script>
  import Editor from '@tinymce/tinymce-vue';

  export default {
    name: 'TextEditor',
    components: {
      Editor,
    },
    data() {
      return {
        apiKey: 'y0vd359uvw73phaniit8ay49zavhqpy16jeb1myadat7ca4g',
      };
    },
    props: {
      height: {
        type: Number,
        default: 200,
      },
      value: {
        type: String,
      },
      name: {
        type: String,
      },
      cssClass: {
        type: String,
      },
    },
    computed: {
      tinyMceInit() {
        return {
          toolbar: 'undo redo | bold italic | alignleft aligncenter alignright'
            + ' | bullist numlist outdent indent | link',
          browser_spellcheck: true,
          menubar: false,
          statusbar: false,
          plugins: 'autoresize lists link',
          content_style: 'body {margin: 5px 15px; padding: 0 5px}',
          min_height: this.height,
          height: this.height,
          autoresize_min_height: this.height,
          autoresize_max_height: this.height + 200,
        };
      },
    },
    methods: {
      input(event) {
        this.$emit('input', event);
      },
      remove(event, editor) {
        editor.save();
      },
    },
  };
</script>
